import AccountTreeIcon from '@mui/icons-material/AccountTree';
import RemoveRedEyeIcon from '@mui/icons-material/RemoveRedEye';
import { Grid, IconButton, Paper, Stack, Typography } from '@mui/material';
import PropTypes from 'prop-types';
import React, { useState } from 'react';

import ProjectInfoModal from './modals/ProjectInfoModal';

const formatDate = (dateString) => {
    const options = { year: 'numeric', month: 'long', day: 'numeric' };
    return new Date(dateString).toLocaleDateString(undefined, options);
};
const TrcMission = ({ project }) => {

    TrcMission.propTypes = {
        project: PropTypes.any,
    };

    const [open, setOpen] = useState(false);
    const handleClose = () => {
        setOpen(false);
    };

    return (
        <Paper
            sx={{ borderRadius: '10px' }}
            elevation={3}
        >
            <Grid
                container
                alignItems="center"
                sx={{ padding: '18px' }}
            >
                <Grid
                    container
                    xs={11}
                >
                    <div
                        style={{
                            padding: '4px',
                            backgroundColor: '#CBE2F1',
                            borderRadius: '4px',
                            display: 'flex',
                            justifyContent: 'center',
                            width: 'fit-content',
                            marginRight: '10px',
                            marginLeft: '10px',
                            marginBottom: '5px',
                            marginTop: '5px',
                        }}
                    >
                        <AccountTreeIcon
                            fontSize="large"
                            sx={{ color: '#FFFFFF' }}
                        />
                    </div>
                    <Stack>
                        <div style={{ display: 'flex', alignItems: 'center', marginBottom: '10px' }}>
                            <Typography
                                fontSize={25}
                                style={{ fontWeight: 'bolder' }}
                            >
                                {project.title}
                            </Typography>
                            <span
                                style={{
                                    paddingRight: '2px',
                                    paddingLeft: '2px',
                                    paddingTop: '1px',
                                    paddingBottom: '1px',
                                    backgroundColor: '#F6ADD1',
                                    marginLeft: '8px',
                                    borderRadius: '3px',
                                    color: '#FFFFFF',
                                    fontSize: 11,
                                }}
                            >
                Projet
                            </span>
                        </div>
                        <Typography
                            fontSize={11}
                            sx={{ marginBottom: '5px', color: '#4D5864' }}
                        >
                            {formatDate(project.createdAt)}
                        </Typography>
                    </Stack>
                </Grid>
                <Grid
                    item
                    xs={1}
                >
                    <IconButton
                        style={{ backgroundColor: '#19223F', color: '#FFFFFF' }}
                        onClick={() => {
                            setOpen(true);
                        }}
                    >
                        <RemoveRedEyeIcon />
                    </IconButton>
                </Grid>
            </Grid>
            <ProjectInfoModal
                open={open}
                handleClose={handleClose}
                project={project}
            />
        </Paper>
    );
};

export default TrcMission;
